/* @flow */
/**
 * External dependencies
 */
import { css } from 'styled-components';
import { includes, noop } from 'lodash';

/**
 * Internal dependencies
 */
import { TAB, SPACE, LEFT, UP, RIGHT, DOWN } from '../../constants/keycodes';
import { hideAccessibleFocus, showAccessibleFocus } from '../../actions/a11y';

/**
 * Flow
 */
import type { Dispatch } from 'redux';

/**
 * Variables
 */
let keyboardNavigation: boolean = false;

/**
 * Redux
 */
export const accessibleFocus = ( dispatch: Dispatch<any> = noop ): void => {
	const keyCodes = [ TAB, SPACE, LEFT, UP, RIGHT, DOWN ];

	document.addEventListener( 'keydown', ( event: KeyboardEvent ): void => {
		if ( keyboardNavigation ) {
			return;
		}

		if ( includes( keyCodes, event.keyCode ) ) {
			keyboardNavigation = true;
			dispatch( showAccessibleFocus() );
		}
	} );

	document.addEventListener( 'mouseup', (): void => {
		if ( ! keyboardNavigation ) {
			return;
		}

		keyboardNavigation = false;
		dispatch( hideAccessibleFocus() );
	} );
};

/**
 * Styled components helper
 */
const focus = ( ...args: any ) => css`
	${ props => props.theme.a11y && props.theme.a11y && css`
		&:focus {
			${ css( ...args ) }
		}
	` }
`;

export default focus;



// WEBPACK FOOTER //
// ./src/utils/accessible-focus/index.js